import styles from './startRecording.module.scss';
import { Button } from 'antd';
import { FaMicrophone } from 'react-icons/fa6';
import { FaCloudUploadAlt } from 'react-icons/fa';
import axios from 'axios';
import { useState } from 'react';
import { FiLoader } from 'react-icons/fi';
import { IWhatIfStory } from 'src/core/repo/whatif/types';
import {
  ITellStoryDetailRes,
  ITellStoryStoriesRes,
} from 'src/core/repo/tellStory/type';

interface Props {
  startRecording: () => void;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
  story?: IWhatIfStory;
  selectedStory?: ITellStoryDetailRes | ITellStoryStoriesRes | null;
}

const StartRecording = ({ startRecording, story, selectedStory }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const toBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (err) => reject(err);
    });
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;
    setIsLoading(true);
    const file = e.target.files[0];

    try {
      const base64String = await toBase64(file);

      // Normalize IDs to support both Tell-Story and What-If shapes
      const storyId =
        (selectedStory as ITellStoryDetailRes | undefined)?.StoryID ??
        (selectedStory as ITellStoryStoriesRes | undefined)?.StoryBankID ??
        story?.StoryID;
      const storyContentId = (
        selectedStory as ITellStoryDetailRes | ITellStoryStoriesRes | undefined
      )?.StoryContentID;
      const childId = (
        selectedStory as ITellStoryDetailRes | ITellStoryStoriesRes | undefined
      )?.ChildID;

      const response = await axios.post(
        'https://app.tadatoon.com/api/voice-file-to-text',
        {
          voice_file: base64String,
          story_id: storyId,
          story_content_id: storyContentId,
          child_id: childId,
        },
      );

      if (response.status === 200) {
        setIsLoading(false);
      }
      console.log('پاسخ سرور:', response.data);
    } catch (error: any) {
      if (error.response) {
        console.error(
          'سرور پاسخ داد با خطا:',
          error.response.status,
          error.response.data,
        );
      } else if (error.request) {
        console.error('پاسخی از سرور نیومد:', error.request);
      } else {
        console.error('خطا در تنظیم درخواست:', error.message);
      }
    }
  };
  return (
    <div className={styles.story_card_description}>
      <div>
        {/* <p className={styles.story_card_picture_count}>Picture 1 of 3</p> */}
        <h3>{story?.StoryTitle}</h3>
        <p className={styles.storyText}>{story?.StoryText}</p>
        <h4>{story?.StoryWhatIf}</h4>
      </div>
      <div className={styles.story_card_action_wrapper}>
        <p>Record your voice OR upload your file</p>
        <div className={styles.story_card_actions}>
          <Button
            onClick={() => void startRecording()}
            className={styles.story_card_record}
            type="primary">
            <FaMicrophone size={20} color="#fff" /> Start Recording
          </Button>
          <input
            onChange={(e) => void handleFileChange(e)}
            type="file"
            name="file-upload"
            id="file-upload"
          />
          <label className={styles.story_card_fileupload} htmlFor="file-upload">
            {isLoading ? (
              <FiLoader />
            ) : (
              <FaCloudUploadAlt size={20} color="#fff" />
            )}
            {isLoading ? 'Loading' : ' Choose File'}
          </label>
        </div>
      </div>
    </div>
  );
};

export default StartRecording;
